export const QUESTIONNAIRE_SELECTOR_ATTRIBUTE = 'data-questionnaire-id';